export const LIST_ALERTS_MANAGEMENT = `
  query ListAlertsManagement($filter: ListAlertsFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    workflow {
      listAlerts(filter: $filter, page: $page, orderBy: $orderBy) {
        items {
          id
          name
          routineName
          assetName
          groupName
          productName
          lastAlertDate
          nextAlertDate
          createdAt
          disabled
        }
        count
        offset
        limit
      }
    }
  }
`;
